import { computed } from "mobx";
import { RacingStore, PageMethodsComposite } from "../../../data/store"
import { RacingEventInfo } from "../../../data/models/RacingEventInfo"

export class RacingFutureEventsData {
    public provider: PageMethodsComposite;
    private racingStore: RacingStore;
    private racingGameNavigation: Function;

    constructor(provider: PageMethodsComposite, openRace: Function) {
        this.provider = provider;
        this.racingStore = RacingStore.getInstance;
        this.racingStore.webMethods = {
            pageMethods: provider.pageMethods,
            racingPageMethods: provider.racingPageMethods
        };
        this.racingGameNavigation = openRace;
    }

    // TODO: Remove when new event view is available
    /* istanbul ignore next */
    openRacingGame(
        racecardId: number,
        regionId: number,
        mode: number,
        branchId: number,
        trapMarketId: number,
        bettingWithoutFavId: number,
        bettingWithoutTwoFavId: number,
        placeOnlyId: number,
        matchBettingId: number,
        toteId: number,
        totePlaceOnlyId: number,
        auPlaceOnlyId: number,
        event: any): void {
        this.racingGameNavigation(
            event,
            racecardId,
            regionId,
            mode,
            branchId,
            trapMarketId,
            bettingWithoutFavId,
            bettingWithoutTwoFavId,
            placeOnlyId,
            matchBettingId,
            toteId,
            totePlaceOnlyId,
            auPlaceOnlyId
        );
    }

    getFutureEventHandler(event: RacingEventInfo): Function {
        return this.openRacingGame.bind(
            this,
            Number(event.id),
            this.racingStore.regionId,
            2,
            Number(this.racingStore.branch.id),
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        )
    }

    getFutureEventUrl(racingEventUrl: string, leagueId: string): string {
        return this.racingStore.getRacingEventUrl(racingEventUrl, leagueId);
    }

    @computed get getAntepostEvents(): RacingEventInfo[] {
        return this.racingStore.sortedAntepostEvents;
    }

    setParams(regionId: number, branchId: number) {
        this.racingStore.setParams(regionId, branchId);
    }
}
